import { FC } from 'react';
import { ITopicDnDResponse } from 'Data/interfaces/Activities/IDragAndDropDataFormat';
import { IMDTheme } from 'Data/interfaces/MultiDomain/IMDTheme';
import AvatarsItems from 'Pages/Activities/components/AvatarsItems';
import { handlePriority, handleVisibility } from 'Utils/ActivitiesUtils';
import { dateToLocaleString, isExpiredDate } from 'Utils/DateUtils';
import { getDisciplineDisplayIcon, getTypeIcon } from 'Utils/ObraUtils';
import Tooltip from 'Components/UI/Tooltip';
import { Icon } from 'Components/UI';
import Ellipsis from 'Components/UI/Ellipsis';
import { ContainerTooltip, MentionContainer } from './styles';

interface IMentionActivityComponentRender {
  activity: ITopicDnDResponse;
  theme: IMDTheme;
}

const MentionActivityComponentRender: FC<IMentionActivityComponentRender> = ({
  activity,
  theme,
}) => {
  return (
    <Tooltip
      placement="top"
      overlay={(
        <ContainerTooltip>
          <div className="top">
            <div className="topLeft">
              <div className="topLeftIdentifier">
                <span className="identifier">{`#${activity?.Identifier}`}</span>
                <Icon
                  icon={getTypeIcon(activity?.Type?.Name || '')}
                  customSize={14}
                  customColor={'#BEC2C6'}
                />
                <span className="type">{activity?.Type?.Name}</span>
              </div>
              <Ellipsis
                phrase={`${activity?.Title} ${activity?.Title} ${activity?.Title}`}
                maxLength={65}
                className='topLeftIdentifierTitle'
              />
              {activity?.DueDate && (
                <div className="topLeftDueDate">
                  <Icon
                    icon="calendar"
                    customSize={16}
                    customColor={isExpiredDate(activity.DueDate) ? theme.colors.danger.danger : theme.colors.surface.onSurfaceVariant}
                  />
                  <span className={`cardDateText ${isExpiredDate(activity.DueDate) ? 'cardDateTextExpired' : ''}`}>
                    {dateToLocaleString(activity.DueDate)}
                  </span>
                </div>
              )}
            </div>
            {activity?.Attachments && activity?.Attachments?.length > 0 && (
              <img
                src={activity?.Attachments[0].Thumbnail128x128Url}
                alt={activity?.Attachments[0].File.Name}
                className="img"
              />
            )}
          </div>
          <div className="bottom">
            <div className="bottomLeft">
              <div className="cardAvatars">
                <AvatarsItems
                  users={activity?.TopicAssignedUsers || []}
                  showDetail
                />
              </div>
              {activity?.ConstructionSiteDisciplines && activity?.ConstructionSiteDisciplines?.length > 0 && (
                <>
                  <div className="dividerWrapper"><div className="divider" /></div>
                  <div className="cardDisciplinesWrapper">
                    {activity.ConstructionSiteDisciplines.map((discipline, index) =>
                      index < 2 ? (
                        <div
                          key={`${discipline.ConstructionSiteDisciplinesId}- ${index}`}
                          className="cardDiscipline"
                        >
                          <Icon
                            icon={getDisciplineDisplayIcon(discipline)}
                            customSize={getDisciplineDisplayIcon(discipline) === 'menuContexto' ? 12 : 14}
                            className="cardDisciplineIcon"
                          />
                        </div>
                      ) : null
                    )}
                    {activity.ConstructionSiteDisciplines.length > 3 && (
                      <span className="cardDisciplineText">
                        {`+${activity.ConstructionSiteDisciplines.length - 3}`}
                      </span>
                    )}
                  </div>
                </>
              )}
            </div>
            <div className="bottomRight">
              {activity?.Visibility && (
                <Icon
                  icon={handleVisibility(activity.Visibility, theme).icon}
                  customSize={handleVisibility(activity.Visibility, theme).size}
                  customColor={handleVisibility(activity.Visibility, theme).color}
                />
              )}
              {activity?.Priority && (
                <Icon
                  icon={handlePriority(activity.Priority, theme).icon}
                  customSize={handlePriority(activity.Priority, theme).size}
                  customColor={handlePriority(activity.Priority, theme).color}
                />
              )}
            </div>
          </div>
        </ContainerTooltip>
      )}
      overlayStyle={{
        backgroundColor: activity?.Status.Color,
        paddingLeft: 5,
        borderRadius: 6
      }}
    >
      <MentionContainer
        color={activity?.Status.Color}
        backgroundColor={activity?.Status.Color}
      >
        <span className="identifierWrapper">
          <span className="identifierIconWrapper">
            <Icon
              icon={getTypeIcon(activity?.Type?.Name || '')}
              customSize={14}
              customColor={activity?.Status.Color}
            />
          </span>
          <span className="identifier">{`#${activity?.Identifier}`}</span>
        </span>
      </MentionContainer>
    </Tooltip>
  );
};

export default MentionActivityComponentRender;
